export const stripeElementsAppearance = {
  // theme: "stripe",

  variables: {
    colorPrimary: "#0570de",
    colorBackground: "#ffffff",
    colorText: "#30313d",
    colorDanger: "#df1b41",
  },
  rules: {
    ".Label": {
      fontWeight: "600",
      fontSize: "fontSizeLg",
      color: "rgb(38 38 38)",
    },
  },
};
